import { NgModule } from '@angular/core';
import { AnchorScrollComponent } from './anchor-scroll.component';

@NgModule({
  declarations: [AnchorScrollComponent],
  exports: [AnchorScrollComponent],
})
export class AnchorScrollModule {}
